import React, { useState } from 'react';
import { AutoComplete } from 'material-ui';

import api from 'services';
import { useRefState } from 'helpers/react.utils';
import { calculateIsIfchorBroker } from 'helpers/realCompanies';

const companiesConfig = {
    text: 'name', 
    value: '_id',
};

function loadCompanies(search, withRealCompanies) {
    if (search.length < 2) {
        return [];
    }
    return api.findCompany(search, withRealCompanies).then((response) => {
        return response.data.data;
    }).catch((err) => {
        console.error(err);
        return null;
    });
}

function DisponentOwner({ disponentOwner, changeField, confirmed, textFieldStyle = undefined, context = undefined }) {
    const [disponents, setDisponents] = useState([]);
    const [search, setSearch, searchRef] = useRefState('');

    const onChangeAutoCompleteDisponent = async (e) => {
        setSearch(e);

        changeField({
            field: 'disponentOwner',
            value: { _id: undefined, name: e },
        });

        let withIfchorBroker;

        if (context) {
            withIfchorBroker = calculateIsIfchorBroker(context.userId.email);
        } 

        const companies = await loadCompanies(e, withIfchorBroker);

        if (searchRef.current !== e) {
            return;
        }

        setDisponents(companies);
    };

    const onChooseAutoCompleteDisponent = (e) => {
        changeField({
            field: 'disponentOwner',
            value: e,
        });
    };
    
    return (
        <AutoComplete
            name='disponentName'
            floatingLabelText='Disponent owner'
            textFieldStyle={{ fontSize: '16px', ...textFieldStyle }}
            hintText='Disponent owner'
            searchText={search || (disponentOwner && disponentOwner.name) || ''}
            dataSource={disponents}
            onUpdateInput={onChangeAutoCompleteDisponent}
            onNewRequest={onChooseAutoCompleteDisponent}
            dataSourceConfig={companiesConfig}
            filter={AutoComplete.noFilter}
            listStyle={{ overflow: 'auto', maxHeight: '300px', width: 'auto' }}
            menuStyle={{ width: 'auto' }}
            popoverProps={{
                canAutoPosition: true,
            }}
            fullWidth
            disabled={confirmed}
        />
    );
}

export default DisponentOwner;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/DisponentOwner.jsx